import { getDefaultSession, getFirstUnitOfSession } from 'data/SessionPlans/accessors';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import StudentApp from './component';

export default ({ getState }) => ({
  path: '(small-stars-app)(online)(trailblazers-app)',
  component: StudentApp,
  actionButtons: {
    default: {
      'View Content': {
        route: ({ params }) => {
          const { groupId } = params;
          const sessionId = getDefaultSession(getState(), groupId).id;
          const unitId = getFirstUnitOfSession(getState(), sessionId);
          return `/group/${groupId}/assign-homework/session/${sessionId}/unit/${unitId}`;
        },
        visibleWhen: ({ params: { groupId } }) =>
            TabSwitcher.isTabEnabled(getState(), groupId, TabCodes.AssignHomework),
      },
    },
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Homework/StudentApp/routes.js